// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
        suggestionMobileStyle: 'style2',
    }
};
(function() {
    BoostPFS.inject(this);
    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
        // If the multi-currency feature is enabled, update the product price
        this.prepareSuggestionProductPriceData();
        // Check on sale
        var onSale = this.data.compare_at_price_min > this.data.price_min;
        // Format price
        var price = Utils.formatMoney(this.data.price_max);
        var compareAtPrice = '';
        if (this.data && this.data.compare_at_price_min) {
            compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
            if (Settings.getSettingValue('search.removePriceDecimal')) {
                price = Utils.removeDecimal(price);
                compareAtPrice = Utils.removeDecimal(compareAtPrice);
            }
        }
        // Build Price
        var result = '';
        if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
            if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
            } else {
                result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
            }
        }
        return result
            .replace(/{{regularPrice}}/g, price)
            .replace(/{{compareAtPrice}}/g, compareAtPrice);
    }
    /* Boost-250698 */
    Utils.buildProductItemUrl = function(data, hasCollection) {
        // Get url information
        var params = Utils.getWindowLocation().search.substring(1);
        var pathname = window.location.pathname;
        var elements = pathname.split('/');
        // Check if has locale
        var localeURLPart = "";
        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
            localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
        }
        // Get product handle
        var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
        var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
        if (hasCollection) {
            // Homepage or Search page
            if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
                var preHandle = localeURLPart + '/collections/all/products/';
                return preHandle + handle;
                // Tag Page
            } else if (Utils.isTagPage()) {
                var preHandle = localeURLPart + '/collections/';
                var collectionHandleIndex = elements.indexOf("collections") + 1
                if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
                return '/collections/all/products/' + handle;
            } else {
                // Google cache URL
                // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
                if (params.indexOf('cache:') > -1) {
                    var collectionHandle = 'all';
                    var temp = params.split('&')[0].split('?')[0].split('collections/');
                    if (temp.length > 1) {
                        if (temp[1].indexOf('/') > -1) {
                            collectionHandle = temp[1].split('/')[0];
                        } else {
                            collectionHandle = temp[1];
                        }
                    }
                    collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                    return '/collections/' + collectionHandle + '/products/' + handle;
                }
                var collectionHandleIndex = elements.indexOf("collections") + 1;
                var preHandle = typeof elements[2] !== 'undefined' && elements[2] === 'collections' ? localeURLPart + '/collections/' : localeURLPart + '/collections/';
                if (typeof elements[2] !== 'undefined') {
                    // Build for collection pages
                    if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
                        return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
                    }
                    //Build for other pages, use collection/all
                    return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
                } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
                    return '/products/' + handle;
                }
                return window.location.pathname + '/products/' + handle;
            }
        }
        return localeURLPart + '/products/' + handle;
    };
    /* Boost-250698 */


  /* start-boost-custom */
/* #boost-: Customize instant search results */
InstantSearchApi.beforeCall = function(searchTerm) {
  Globals.instantSearchQueryParams.q = Utils.encodeURIParamValue(unescape(searchTerm || '').replace(/&#x27;/g, "'").replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' '));
  if (!Globals.instantSearchQueryParams.q) Globals.instantSearchQueryParams.q = searchTerm // avoid breaking the search
}

var searchSubmit = SearchInput.prototype._onSubmit;
  
SearchInput.prototype._onSubmit = function(event, redirect) {
  searchSubmit.call(this, event, redirect);
  
  var term = unescape(Globals.currentTerm || '').replace(/&#x27;/g, "'").replace(/&#x26;/g, '').replace(/&#x2A;/gi, '').replace(/-/g, ' ');
  var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(term);
  
  var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
  
  if (isApiReturnedResult) {
    if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
      Utils.setWindowLocation(redirectUrl);
    } else {
      this.isChangePage = true;
      this.$searchForm[0].submit();
    }
  } 
}
/* end-boost-custom */
  
})();